/**
 * Phase K Pass 1 — Canonical dashboard catalog.
 *
 * Keep this list in lock-step with backend/routers/dashboard_prefs.py.
 * The backend serves the same data via GET /api/admin/dashboard-cards-catalog;
 * at runtime the frontend prefers the server payload (so a future card add
 * doesn't require a frontend redeploy), but this static copy is used as
 * the bootstrap render before the API responds.
 */

export const DASHBOARD_TABS = [
    { id: "today", label: "Today" },
    { id: "onboarding", label: "Onboarding & Customers" },
    { id: "contracts", label: "Contracts & Compliance" },
    { id: "rentals", label: "Rentals & Equipment" },
    { id: "billing", label: "Billing & Invoicing" },
    { id: "payments", label: "Payments & Reconciliation" },
    { id: "system", label: "System & Activity" },
];

export const DASHBOARD_CARDS = [
    // Onboarding & Customers
    { key: "pending-review", tab: "onboarding", label: "Pending review", defaultHidden: false, requiresSuperAdmin: false },
    { key: "approved", tab: "onboarding", label: "Approved", defaultHidden: true, requiresSuperAdmin: false },
    { key: "rejected", tab: "onboarding", label: "Rejected", defaultHidden: true, requiresSuperAdmin: false },
    { key: "invites", tab: "onboarding", label: "Invites pending", defaultHidden: false, requiresSuperAdmin: false },
    { key: "drafts", tab: "onboarding", label: "Customer drafts", defaultHidden: false, requiresSuperAdmin: false },
    { key: "customers", tab: "onboarding", label: "Customers", defaultHidden: false, requiresSuperAdmin: false },
    // Contracts & Compliance
    { key: "safer-risk", tab: "contracts", label: "SAFER risk flags", defaultHidden: false, requiresSuperAdmin: false },
    { key: "safer-reverify", tab: "contracts", label: "SAFER re-verify", defaultHidden: false, requiresSuperAdmin: false },
    { key: "pending-signatures", tab: "contracts", label: "Pending signatures", defaultHidden: false, requiresSuperAdmin: false },
    { key: "coi-expiring", tab: "contracts", label: "COIs expiring soon", defaultHidden: false, requiresSuperAdmin: false },
    // Phase COI-REFRESH — richer widget with per-rental rows + refresh state.
    { key: "coi-expiring-soon-widget", tab: "contracts", label: "COI expiring soon (details)", defaultHidden: false, requiresSuperAdmin: false },
    // Rentals & Equipment
    { key: "renewal-acceptance", tab: "rentals", label: "Renewal acceptance rate", defaultHidden: false, requiresSuperAdmin: false },
    { key: "renewal-radar", tab: "rentals", label: "Renewal Radar", defaultHidden: false, requiresSuperAdmin: false },
    { key: "active-rentals", tab: "rentals", label: "Active rentals", defaultHidden: false, requiresSuperAdmin: false },
    // Billing & Invoicing
    { key: "invoices", tab: "billing", label: "Invoices", defaultHidden: false, requiresSuperAdmin: false },
    { key: "invoice-aging", tab: "billing", label: "Outstanding invoices", defaultHidden: false, requiresSuperAdmin: false },
    { key: "schedules-at-risk", tab: "billing", label: "Schedules at risk", defaultHidden: false, requiresSuperAdmin: false },
    // Phase J.8 (2026-08-01) — Released-without-invoice diagnostic widget.
    { key: "uninvoiced-releases", tab: "billing", label: "Released without invoice", defaultHidden: false, requiresSuperAdmin: true },
    // Payments & Reconciliation
    { key: "payment-activity", tab: "payments", label: "Payment activity", defaultHidden: false, requiresSuperAdmin: false },
    { key: "auto-charge-attempts-summary", tab: "payments", label: "Auto-charge attempts", defaultHidden: false, requiresSuperAdmin: false },
    // System & Activity
    { key: "mock-emails", tab: "system", label: "Mock email outbox", defaultHidden: false, requiresSuperAdmin: true },
    { key: "admins", tab: "system", label: "Admins", defaultHidden: false, requiresSuperAdmin: true },
    { key: "cron-health", tab: "system", label: "Cron health", defaultHidden: false, requiresSuperAdmin: true },
    { key: "email-failures", tab: "system", label: "Email failures (24h)", defaultHidden: false, requiresSuperAdmin: true },
    { key: "impersonations-7d", tab: "system", label: "Impersonations (7d)", defaultHidden: false, requiresSuperAdmin: true },
];

export const DEFAULT_TAB_ID = "today";

export const DEFAULT_HIDDEN_CARD_KEYS = DASHBOARD_CARDS
    .filter((c) => c.defaultHidden)
    .map((c) => c.key);

export function findCard(key) {
    return DASHBOARD_CARDS.find((c) => c.key === key) || null;
}

export function cardsForTab(tabId) {
    return DASHBOARD_CARDS.filter((c) => c.tab === tabId);
}

export function tabById(tabId) {
    return DASHBOARD_TABS.find((t) => t.id === tabId) || null;
}
